import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  /**
  The Dsn used to connect to Sentry and identify the project. If omitted, the SDK will not send any data to Sentry. 
  */
  dsn: environment.sentryConfiguration.dsn,
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: environment.sentryConfiguration.tracingOrigins,
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],

  tracesSampleRate: environment.sentryConfiguration.tracesSampleRate,
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
